import { Icon, IconName } from '@ardoq/icons';
import { colors, s4 } from '@ardoq/design-tokens';
import { Checkbox } from '@ardoq/forms';
import { caption } from '@ardoq/typography';
import styled from 'styled-components';
import { GhostButton } from '@ardoq/button';
import { ReactNode } from 'react';
import { FlexBox } from '@ardoq/layout';

type ClosableNotificationProps = {
  dismissNotification: () => void;
  dontShowAgain: boolean;
  setDontShowAgain: (value: boolean) => void;
  children: ReactNode;
};

export const ClosableNotification = ({
  dontShowAgain,
  setDontShowAgain,
  children,
  dismissNotification,
}: ClosableNotificationProps) => {
  return (
    <Container padding="medium" gap="small" align="center">
      <Icon iconName={IconName.INFO} color={colors.icon} />
      <BannerText>{children}</BannerText>
      <Checkbox isChecked={dontShowAgain} onChange={setDontShowAgain}>
        <CheckboxLabel>Don&apos;t show this again</CheckboxLabel>
      </Checkbox>
      <GhostButton onClick={dismissNotification}>
        <Icon iconName={IconName.CLOSE} />
      </GhostButton>
    </Container>
  );
};

const Container = styled(FlexBox)`
  border: 1px solid ${colors.borderAction};
  background-color: ${colors.surfaceStatusNeutral};
  border-radius: ${s4};
`;

const CheckboxLabel = styled.span`
  ${caption};
  white-space: nowrap;
`;

const BannerText = styled.span`
  margin-right: auto;
`;
